import { motion } from 'framer-motion';
import { EASE } from '../engine/sceneTime';

// Word-by-word kinetic headline. `show` flips once; framer handles the reveal.
export function Words({ text, show, delay = 0, stagger = 0.08, className = '', style, size = 112, lime = [], hide = false, nowrap = false }) {
  const words = String(text).split(' ');
  return (
    <div className={`pk-words ${nowrap ? 'pk-words-nowrap' : ''} ${className}`} style={{ fontSize: size, ...style }} aria-label={text}>
      {words.map((w, i) => (
        <span key={`${w}-${i}`} className="pk-word-clip">
          <motion.span
            className={`pk-word ${lime.includes(i) ? 'pk-lime' : ''}`}
            initial={false}
            animate={show && !hide ? { y: '0%', opacity: 1 } : { y: hide ? '-110%' : '110%', opacity: 0 }}
            transition={{ duration: 0.75, delay: show && !hide ? delay + i * stagger : i * 0.03, ease: EASE }}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </div>
  );
}

export function Fade({ show, delay = 0, y = 28, x = 0, scale, duration = 0.8, className = '', style, children, blur = false, ...rest }) {
  return (
    <motion.div
      className={className}
      style={style}
      initial={false}
      animate={show
        ? { opacity: 1, y: 0, x: 0, scale: 1, filter: 'blur(0px)' }
        : { opacity: 0, y, x, scale: scale ?? 1, filter: blur ? 'blur(12px)' : 'blur(0px)' }}
      transition={{ duration, delay: show ? delay : 0, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function Line({ show, delay = 0, width = 320, height = 3, className = '', style, origin = 'left', duration = 1.1 }) {
  return (
    <motion.div
      className={`pk-line ${className}`}
      style={{ width, height, transformOrigin: origin, ...style }}
      initial={false}
      animate={{ scaleX: show ? 1 : 0, opacity: show ? 1 : 0 }}
      transition={{ duration, delay: show ? delay : 0, ease: EASE }}
    />
  );
}

export function Eyebrow({ show, delay = 0, children, className = '', style }) {
  return (
    <Fade show={show} delay={delay} y={14} className={`pk-eyebrow ${className}`} style={style}>{children}</Fade>
  );
}
